// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".js-focus-visible :focus:not(.focus-visible) {\n  outline: none;\n}", "",{"version":3,"sources":["/codebuild/output/src3709934818/src/node_modules/@amway/shared-components/shared-assets/src/lib/styles/_focus-visible.scss","_focus-visible.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;ACCF","file":"_focus-visible.scss","sourcesContent":[".js-focus-visible :focus:not(.focus-visible) {\n  outline: none;\n}\n",".js-focus-visible :focus:not(.focus-visible) {\n  outline: none;\n}"]}]);
// Exports
module.exports = exports;
